<div class="modal">
  <div class="container">
      <div class="row">
          <div class="col-sm-8"></div>
          <div class="col-sm-4 col-xs-12">
              <div class="icon-container" style="cursor: pointer;">
                <div class="icon">
                  <img (click)="zoomIn()" src="/assets/img-svg/zoom_in_white_24dp.svg" alt="">
                </div>
                  <div class="icon">
                    <img (click)="zoomOut()" src="/assets/img-svg/zoom_out_white_24dp.svg" alt="">
                  </div>
                  <a *ngIf="!!currentDetalle" class="icon" [href]="getDownloadPath(currentDetalle.IMAGENURL)" download>
                    <img src="/assets/img-svg/file_download_white_24dp.svg" alt="">
                  </a>
                  <div class="icon" (click)="back()">
                    <img src="/assets/img-svg/cancel_white_24dp.svg" alt="">
                  </div>
              </div>
          </div>
      </div>
      <br>
      <div>
        <div class="row">
          <div class="caption col-sm-12 col-xs-12 col-md-10 col-md-offset-1">
            {{language.BLOQUE_TEXT + ' ' + bloque}}
          </div>
        </div>
        <gallery (indexChange)="galleryIndexChange($event)" [items]="detalles" [gestures]="false" [counter]="false"
          [itemTemplate]="itemTemplate" [thumb]="false" class="zoom"></gallery>
        <!-- <div class="row bookmatch">
          <div class="col-sm-12 col-xs-12 col-md-10 col-md-offset-1" *ngIf="!!imgSrc">
            <div class="">
              <pinch-zoom [backgroundColor]="'#111'">
                <img [src]="imgSrc">
              </pinch-zoom>
            </div>
          </div>
        </div> -->
        
      </div>
      <br>
      <br>
      <br>
  </div>
</div>


<ng-template #itemTemplate let-index="index" let-type="type" let-data="data" let-currIndex="currIndex">
  <ng-container *ngIf="index === currIndex">
    <pinch-zoom [backgroundColor]="'#111'" [overflow]="'visible'" (touchend)="tgglGesture()">
      <img [src]="currentDetalle.IMAGENURL">
    </pinch-zoom>
  </ng-container>
</ng-template>